/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_One_Time_Modal_Security_NoteInputs */

const es_user_profile_api_keys_one_time_modal_security_note = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por razones de seguridad, no podrás volver a ver esta clave. Si la perdés, deberás regenerarla.`)
};

const en_user_profile_api_keys_one_time_modal_security_note = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For security reasons, you won't be able to view this key again. If you lose it, you will need to regenerate it.`)
};

/**
* | output |
* | --- |
* | "For security reasons, you won't be able to view this key again. If you lose it, you will need to regenerate it." |
*
* @param {User_Profile_Api_Keys_One_Time_Modal_Security_NoteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_one_time_modal_security_note = /** @type {((inputs?: User_Profile_Api_Keys_One_Time_Modal_Security_NoteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_One_Time_Modal_Security_NoteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_one_time_modal_security_note(inputs)
	return en_user_profile_api_keys_one_time_modal_security_note(inputs)
});
export { user_profile_api_keys_one_time_modal_security_note as "user.profile.api_keys.one_time_modal.security_note" }